import { createRoutine } from 'redux-saga-routines';

export const clearNotificationsData = createRoutine('CLEAR_NOTIFICATIONS_DATA');
export const createNotification = createRoutine('CREATE_NOTIFICATION');
export const sendNotification = createRoutine('SEND_NOTIFICATION');
export const sendNotificationToAllActiveUsers = createRoutine('SEND_NOTIFICATION_TO_ALL_ACTIVE_USERS');
export const sendNotifications = createRoutine('SEND_NOTIFICATIONS');
export const stopSyncingNotifications = createRoutine('STOP_SYNCING_NOTIFICATIONS');
export const syncNotifications = createRoutine('SYNC_NOTIFICATIONS');
export const updateRecipientStatus = createRoutine('UPDATE_RECIPIENT_STATUS');
export const getStatsForPushNotifications = createRoutine('GET_STATS_FOR_PUSH_NOTIFICATIONS');
